import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';
var StPetersburg = function () {
    return (<>
            <g id={'guts'}>
                <path d='M18.8571 13H20M18.8571 13L14.2857 5M18.8571 13L17.5936 13.6318C16.9501 13.9535 16.1927 13.9535 15.5492
                        13.6318L15.3079 13.5111C14.6644 13.1894 13.907 13.1894 13.2635 13.5111L13.0222 13.6318C12.3787 13.9535
                        11.6213 13.9535 10.9778 13.6318L10.7365 13.5111C10.093 13.1894 9.33558 13.1894 8.69208 13.5111L8.45077
                        13.6318C7.80728 13.9535 7.04986 13.9535 6.40637 13.6318L5.14286 13M4 13H5.14286M5.14286 13L9.71429 5M18.8571
                        17.5714L17.5936 18.2032C16.9501 18.5249 16.1927 18.5249 15.5492 18.2032L15.3079 18.0825C14.6644 17.7608 13.907
                        17.7608 13.2635 18.0825L13.0222 18.2032C12.3787 18.5249 11.6213 18.5249 10.9778 18.2032L10.7365 18.0825C10.093
                        17.7608 9.33558 17.7608 8.69208 18.0825L8.45077 18.2032C7.80728 18.5249 7.04986 18.5249 6.40637 18.2032L5.14286 17.5714' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            </g>
        </>);
};
export default createSvg(StPetersburg, 'StPetersburg');
